import {
    HttpTransportType,
    HubConnectionBuilder,
    LogLevel,
} from "@microsoft/signalr";
import * as Constants from "common/helpers/constants";
import reduxSignalRMiddleware, {
    withCallbacks,
} from "common/realtime/redux-signalr-middleware";
import Guid from "common/values/guid/guid";
import NotificationAPIResponse from "notifications/entities/notification/api/response-contracts/notification-api-response";
import { addNotification, removeNotification } from "notifications/entities/notification/store/notifications-redux-slice";
import Session from "users/session/session";
  
  export const notificationsHubConnection = new HubConnectionBuilder()
    .configureLogging(LogLevel.Debug)
    .withUrl(`${Constants.apiBaseUrl}/notificationHub`, {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets,
      accessTokenFactory: () =>
        Session.loadFromStorage(() => {}).authToken?.value ?? "",
    })
    .withAutomaticReconnect()
    .build();

  const toNotification = (payload: unknown) =>
    Object.assign(new NotificationAPIResponse(), payload as object).deserialize();
  
  const callbacks = withCallbacks()
    .add("notification-received", (payload: unknown) => (dispatch) => {
      const notification = toNotification(payload);
      dispatch(addNotification(notification));
    })
    .add("notification-updated", (payload: unknown) => (dispatch) => {
        const notification = toNotification(payload);
        dispatch(addNotification(notification));
      })    
    .add("notification-deleted", (payload: unknown) => (dispatch) => {
      const deletedNotificationId = new Guid((payload as { id: string }).id);
      dispatch(removeNotification(deletedNotificationId));
    });
  
  export const notificationsSignalRReduxMiddleware = reduxSignalRMiddleware({
    callbacks,
    connection: notificationsHubConnection,
    shouldConnectionStartImmediately: true,
  });
  